@if (deviceReady()) {
  <div [ngClass]="cssClass()" class="w-full">
    <div class="w-full max-w-[1208px] mx-auto px-3">
      @if (isMobile()) {
        <app-search-widget-v3-mobile [isOnTop]="atTop()" [isInline]="isInline()"></app-search-widget-v3-mobile>
        @if (isSearchWidgetExpanded()) {
          <div [@fadeAnimation] class="fixed inset-0 z-50">
            <app-search-widget-v3-mobile-expanded
              [shouldFocusPlacesField]="shouldFocusPlacesField()"></app-search-widget-v3-mobile-expanded>
          </div>

          <app-search-categories-mobile-panel-v3></app-search-categories-mobile-panel-v3>
          <app-search-places-mobile-panel-v3></app-search-places-mobile-panel-v3>
        }
      } @else {
        <app-search-widget-v3-desktop [isOnTop]="atTop()" [isInline]="isInline()"></app-search-widget-v3-desktop>
        @if (isSearchWidgetExpanded()) {
          <div class="fixed inset-0 z-10" (click)="closeDesktopExpandedPanel()"></div>
          <div [@fadeAnimation] class="fixed top-0 left-0 right-0 z-50 shadow-lg transition-all"
               [ngClass]="desktopExpandedCssClass()">
            <app-search-widget-v3-desktop-expanded
              [shouldFocusPlacesField]="shouldFocusPlacesField()"></app-search-widget-v3-desktop-expanded>
          </div>
        }
      }
    </div>
  </div>
} @else {
  <div [ngClass]="placeholderCssClass()" class="w-full px-3"></div>
}
